<template>
    <ac-modal :title="'Edit Clinic Identifier'" ref="modal">
        <template>
            <form>
                <div class="row">
                    <div class="info-board info-board-blue">
                        <p>
                            The UniqueClinicId is used to associate a clinic in Accresa with one being uploaded through the Spreadsheet Uploader.
                            We use this Id to match clinics in the spreadsheet with existing clinics, and to associate physicians uploaded through
                            the spreadsheet tool to this clinic.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <label for="uniqueClinicId">UniqueClinicId</label><br/>
                        <input class="form-control" type="text" name="uniqueClinicId" id="uniqueClinicId" v-model="vm"/>
                    </div>
                </div>
            </form>
        </template>
        <template slot="buttons">
            <ac-button type="button" class="btn btn-red btn-sm" :action="closeModal">Close</ac-button>
            <ac-button class="btn btn-green btn-sm" role="button" :action="save">Save</ac-button>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../global/framework/api.js";

    export default {
        name: "ClinicIdModal",
        inheritAttrs: false,
        props: {
            clinicId: {required: true, validator: prop => typeof prop === 'string' || prop === null},
            providerEntityId: {type: [Number], required: true},
            parentId: {type: [Number], required: true}
        },
        data() {
            return {
                vm: this.clinicId
            }
        },
        methods: {
            showModal() {
                this.$refs.modal.open();
            },
            closeModal() {
                this.$refs.modal.close();
            },
            async save() {
                let result = await api.post('ProviderEntity', 'SaveUniqueClinicId', {
                    providerEntityId: this.providerEntityId,
                    parentId: this.parentId,
                    uniqueClinicId: this.vm
                });
                if (result) {
                    this.$emit('clinic-id-updated', this.vm);
                    this.closeModal();
                }
            }
        }
    }
</script>

<style scoped>

</style>